import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';

import './page.scss';

interface Props {
  children?: ReactNode | ReactNode[];
}

export const Page = ({ children }: Props) => {
  return (
    <div className="page">
      <div className={classNames('main', { 'is-desktop': !isMobile })}>{children}</div>
    </div>
  );
};
